<template>
	<van-swipe :autoplay="6000" :show-indicators=true>
	  <van-swipe-item v-for="(image, index) in images" :key="index">
		 <img :src="image.Column1" class="imgSwiper" @click="Previewimg(images,index)"/>		 
	  </van-swipe-item>
	</van-swipe>
</template>

<script>	
	import Vue from 'vue'	
	export default {	  
	  name: 'swiper',
	  props: {
	    msg: String
		},
	   data() {
	      return {
			 images:[]
	      }
	    },
		created(){		
			this.getData();
		},				
		methods:{
			getData(){
				var that = this
				Vue.axios.get('https://t3.lenovoimage.com/api/web2/getswiperbyappid2023?appid=svchome')
				 .then(function (response) {
				  that.images = response.data.Data;
				 })
				 .catch(function (error) {
				  console.log(error);
				 });
			},
			 // 轮播图预览
			Previewimg(images, index) {	
					if (images[index].ImgLink != null)
					{
						//alert('aaa' + images[index].ImgLink)
						window.location.href = images[index].ImgLink;
					}
					else
					{
						//alert('bbb' + images[index].RecID + images[index].ImgLink)
					}
					
				
				}
			
		}
	  }
</script>

<style>
	.my-swipe .van-swipe-item {
	  color: #fff;
	  font-size: 20px;
	  line-height: 150px;
	  text-align: center;
	  background-color: #39a9ed;
	}
	.imgSwiper{
		max-width: 100%;
	}
</style>
